<div class="tw-flex tw-h-8 tw-items-center tw-justify-center tw-gap-2 tw-overflow-hidden tw-bg-gradient-delivery-info tw-px-4 tw-py-2">
  <p class="tw-font-body tw-text-200 tw-font-bold tw-italic tw-text-gray-800">
    @switch (bucket()) {
      @case (Bucket.Tomorrow) {
        <ng-container i18n="@@orderFlowDeliveryByTomorrow">Expected delivery by tomorrow</ng-container>
      }
      @case (Bucket.WithinThreeDays) {
        <ng-container i18n="@@expectedDeliveryWithin3Days">Expected delivery within 3 days</ng-container>
      }
      @case (Bucket.DateRange) {
        <ng-container i18n="@@expectedDeliveryOn">Expected delivery on</ng-container> {{ expectedDeliveryDate().from | date: 'd MMM' }} - {{ expectedDeliveryDate().to | date: 'd MMM' }}
      }
      @default {
        <ng-container i18n="@@expectedDeliveryWithin2Days">Expected delivery within 2 days</ng-container>
      }
    }
  </p>
  <div class="tw-relative tw-h-6 tw-w-10 tw-shrink-0 tw-overflow-hidden">
    <img class="tw-absolute tw-left-1/2 tw-top-1/2 tw-h-18 tw-w-18 tw-max-w-none -tw-translate-x-1/2 -tw-translate-y-1/2 tw-mix-blend-multiply"
      src="/assets/gifs/delivery-truck.gif" alt="" />
  </div>
</div>
